import { refreshTokenSelector } from '@data/selectors/authSelectors';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  LoginInput,
  LoginResponse,
  postLogin,
  postPasswordLessLogin,
  postRegister,
  refreshAccessToken,
  RegisterInput,
} from '@api/auth';
import { DefaultReduxThunkApiConfig } from '@shared/types';
import { handleReduxError } from '@utils/requests';
import { i18n } from '@components/i18n';

export const loginUserAction = createAsyncThunk<
  LoginResponse | undefined,
  LoginInput,
  DefaultReduxThunkApiConfig
>('user/login', async (loginInput: LoginInput, { rejectWithValue }) => {
  try {
    const res = await postLogin(loginInput);

    return res;
  } catch (error: unknown) {
    return rejectWithValue(handleReduxError(error, i18n.t));
  }
});

export const logoutAction = createAction('logout');

export const registerUserAction = createAsyncThunk<
  LoginResponse | undefined,
  RegisterInput,
  DefaultReduxThunkApiConfig
>(
  'user/register',
  async (registerInput: RegisterInput, { rejectWithValue }) => {
    try {
      const res = await postRegister(registerInput);
      return res;
    } catch (error: unknown) {
      return rejectWithValue(handleReduxError(error, i18n.t));
    }
  }
);

export const refreshAccessTokenAction = createAsyncThunk<
  LoginResponse | undefined,
  undefined,
  DefaultReduxThunkApiConfig
>('auth/refreshAccessToken', async (_unused, { rejectWithValue, getState }) => {
  const state = getState();
  try {
    const refreshToken = refreshTokenSelector(state);
    const response = await refreshAccessToken(refreshToken ?? '');
    return response;
  } catch (error: unknown) {
    return rejectWithValue(handleReduxError(error, i18n.t));
  }
});

export const passwordlessLoginUserAction = createAsyncThunk<
  LoginResponse | undefined,
  string,
  DefaultReduxThunkApiConfig
>('user/login', async (token: string, { rejectWithValue }) => {
  try {
    const res = await postPasswordLessLogin(token);
    return res;
  } catch (error: unknown) {
    return rejectWithValue(handleReduxError(error, i18n.t));
  }
});
